import {Component, EventEmitter, Input, Output, QueryList, SimpleChanges, ViewChild, ViewChildren} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormLabelMode, LabelLocation} from "devextreme/ui/form";
import {DkGlobalUserSettingsService, LookupResTypeEnum} from "@dabnet-kamu/libs/ui";
import {LabelMode} from "devextreme/common";
import {DxiValidationRuleComponent} from "devextreme-angular/ui/nested";
import {DxFormComponent, DxSelectBoxModule, DxTagBoxModule, DxValidatorComponent, DxValidatorModule} from "devextreme-angular";
import {CtGenLookupService} from "../ct-gen-lookup/ct-gen-lookup.service";
import {DxTagBoxTypes} from "devextreme-angular/ui/tag-box";
import { TagBoxValuePipePipe } from '../../pipes/tag-box-value-pipe/tagBoxValuePipe.pipe';


@Component({
  selector: 'dk-ct-gen-tag-box',
  standalone: true,
  imports: [CommonModule, DxTagBoxModule, DxSelectBoxModule,TagBoxValuePipePipe,
    DxValidatorModule
  ],
  templateUrl: './ct-gen-tag-box.component.html',
  styleUrls: ['./ct-gen-tag-box.component.scss'],
})
export class CtGenTagBoxComponent {
  @Output() valueChange = new EventEmitter<any>();
  @Output() resultValidation = new EventEmitter<any>();
  @Input() placeholder = '';
  @Input() label = '';
  @Input() labelMode: FormLabelMode = this.globalSettings.globalLabelMode;
  @Input() labelLocation: LabelLocation = this.globalSettings.globalLabelLocation;
  @Input() selectedValue: any;
  @Input() lookUpType = '';
  @Input() mainCode = 0;
  @Input() periodCode = 0;
  @Input() maxDisplayedTags = 3;
  @Input() page = '';
  @Input() count = '';
  @Input() type = '';
  @Input() disabled = false;
  @Input() readOnly = false;
  @Input() showSelectionControls = false;
  @Input() selectedFirstItem = false;
  @Input() valueExpr = LookupResTypeEnum.OzelKod || 'ozelKod';
  @Input() validationRules: any[] | null = [];
  @Input() isRequired:boolean = false;
  @Input() searchEnabled:boolean = false;
  @Input() showDropDownButton:boolean = false;
  // 'useButtons': seçimler Tamam'a basılınca tek seferde işlenir (valueChange bir kez tetiklenir)
  @Input() applyValueMode: 'instantly' | 'useButtons' = 'instantly';
  formChanged = false;
  dataSource: any;
  isFormValid: boolean = false;
  public labelModeNew: LabelMode = null;
  @ViewChildren('validationRule') validationRule: QueryList<DxiValidationRuleComponent>;
  @ViewChild(DxFormComponent, {static: false}) form: DxFormComponent;
  @ViewChild(DxValidatorComponent,{static:false}) validator:DxValidatorComponent;

  constructor(private ctGenlookupService: CtGenLookupService,
    private globalSettings:DkGlobalUserSettingsService
  ) {
  }

  ngOnInit(): void {
    if (!this.disabled) {
      this.getDataSource();
    }
    if (this.labelMode !== 'outside') this.labelModeNew = this.labelMode;
    else this.labelModeNew = null;

    console.log('Tag box yeniden oluşturulu.')
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes['mainCode'] &&
      changes['mainCode'].currentValue > 0
    ) {
      this.getDataSource();
    }
    if (
      changes ||
      changes['validationRules']
    ) {

    }
  }

  onValueChange(e: any) {
    const newValue =
      this.type === 'number'
        ? (Array.isArray(e.value) ? e.value : [e.value]).map((x: any) => Number(x))
        : (Array.isArray(e.value) ? e.value : [e.value]);

    this.valueChange.emit(newValue);
    this.onFormChange(newValue);
  }

  onFormChange(value: any) {
    if (value !== undefined && value !== null) {
      this.formChanged = true;
      this.isFormValid = this.form?.instance?.validate().status === 'valid';
    }
    this.resultValidation.emit(this.isFormValid);
  }


  customCallback(e: any) {
    // if (this.checkBoxValue) {
    //     return !!e.value;
    // }
    // return true;
  }

  getDataSource(): void {
    this.ctGenlookupService
      .genLookup(
        this.lookUpType,
        this.mainCode,
        this.periodCode,
        this.page,
        this.count
      )
      .subscribe((data) => {
        this.dataSource = data.items;
        if (this.dataSource?.length === 1 && this.selectedFirstItem) {
          this.selectedValue = this.dataSource[0][this.valueExpr];
        }
      });
  }

  protected readonly LookupResTypeEnum = LookupResTypeEnum;

  onMultiTagPreparing(args: DxTagBoxTypes.MultiTagPreparingEvent) {
    // const selectedItemsLength = args.selectedItems.length;
    // const totalCount = 5;
    //
    // if (selectedItemsLength < totalCount) {
    //   args.cancel = true;
    // } else {
    //   args.text = `Seçilen (${selectedItemsLength})`;
    // }
  }

}
